import { httpClient } from "../httpClient";

type RequestHeader = {
  id: number; // Response only?
  dateAdded: string; // Response only
  requestType: 1 | 2 | 3;
  justification: string | undefined; // null?
  draftRequestForself: boolean; // undefined? null?
  effectiveDate: string | undefined; // null?
};

type UserList = {
  emailAddress: string;
  networkId: string;
  name: string;
  revokeType: string | undefined; // null?
  startDate: string | undefined; // null?
  isAdvance: boolean | undefined; // null?
}[];

type AppList = {
  keyId?: string;
  appId: number;
  appName: string;
  appFormId?: number;
  host: string;
  appType: string;
  environmentVal?: string;
  environment: string;
  environmentId: number;
  role: string;
  roleId: number;
  deviceTypeAppId?: number;
  infraAppId: number;
  details: string;
  device?: string;
}[];

type InfraDetails = {
  infraKeyId?: string;
  environmentVal?: number;
  infraAppId?: number;
  environment?: string;
  role?: string;
  subCategoryName?: string;
  details?: string;
  device?: string;
  deviceTypeId?: string;
  infraApp?: number;
  environmentId?: number;
  roleId?: number;
}[];

type AppValues = {
  id: number;
  appName: string;
  host: string;
  type: string;
  accessDetailNote: string | undefined;
  additionalForm: string | undefined;
  categoryId: number;
  systemTypeId: number;
  singleRequest: boolean;
  uamNote: string | undefined;
  formTemplate: string | undefined;
  formTemplate2: string | undefined;
  isRevokeNeededForm: boolean;
  mobileAttestation: boolean;
}[];

type RoleValues = {
  isActive?: boolean;
  csubCategories_fk?: number;
  csystemType_fk?: number;
  id: number;
  approver1?: string;
  approver2?: string;
  approver3?: string;
  approver4?: string;
  roleName: string;
  addedBy?: string;
  approver2Level?: string;
  approver3Level?: string;
  approver4Level?: string;
  approver1Level?: string;
}[];

type EnvironmentValues = {
  isActive?: boolean;
  id: number;
  environmentName: string;
}[];

type InfraAppValues = {
  isActive?: boolean;
  id: number;
  appName: string;
}[];

export type Draft = {
  id: number;
  requestHeader: RequestHeader;
  userList: UserList;
  appList: AppList;
  infraDetails: InfraDetails;
  appValues: AppValues;
  roleValues: RoleValues;
  environmentValues: EnvironmentValues;
  infraAppValues: InfraAppValues;
};

export type Payload = {
  requestHeader: Omit<RequestHeader, "id" | "dateAdded">;
  userList: UserList;
  appList: AppList;
  infraDetails: InfraDetails;
  appValues: AppValues;
  roleValues: RoleValues;
  environmentValues: EnvironmentValues;
  infraAppValues: InfraAppValues;
  id: number | undefined
};

export async function delDraft(id: number): Promise<Draft> {
  try {
    const { data } = await httpClient.delete(`/api/v1/drafts/${id}`);

    return data;
  } catch (error) {
    throw error;
  }
}

export async function getDrafts(): Promise<Draft[]> {
  try {
    const { data } = await httpClient.get<{
      drafts: Draft[];
    }>(`/api/v1/drafts`);

    return data.drafts;
  } catch (error) {
    throw error;
  }
}

export async function getDraftById(id: number): Promise<Draft> {
  try {
    const { data } = await httpClient.get<{
      draft: Draft;
    }>(`/api/v1/drafts/${id}`);

    return data.draft;
  } catch (error) {
    throw error;
  }
}

export async function postDraft(payload: any): Promise<Draft> {
  try {
    const { data } = await httpClient.post<Draft>(`/api/v1/drafts`, payload);

    return data;
  } catch (error) {
    throw error;
  }
}

export const drafts = {
  delDraft,
  getDrafts,
  getDraftById,
  postDraft,
};
